'use client'
import { useCurrentUser } from '@/hooks/useCurrentUser'

export function useIsAdmin() {
  const { user, loggedIn, isLoading } = useCurrentUser()

  const isAdmin = loggedIn === true && user?.is_admin === true
  return { isAdmin, loading: isLoading }
}
